import React from 'react';
import { ACCEPT_EULA, PROCESS_EULA, EULA_ERROR } from '../actions/eulaActions';
import { apiRequest } from '../actions/apiActions';
import { showLoading, hideLoading, addUiMsg } from '../actions/uiActions';
import { apiUrls, apiVersion } from '../../apiUrls';
import { FormattedMessage } from 'react-intl';
import { errorDisplay } from '../../utilities/general';
import { messageTypes } from '../../components/ui/AlertMessage';

/**
 * Middleware to trigger an api call to tell the database that the current user has accepted the EULA
 */
export const acceptEula = (store) => (next) => (action) => {
  next(action);
  if (action.type === ACCEPT_EULA) {
    const userInfo = store.getState().currentUser;
    const date = new Date();
    const dateString = date.toISOString();
    //const software_version =  window.ENV.EULA_VERSION;
    //console.log("EULA_VERSION in middleware:", software_version);
    const body = {
      eula_user_id: userInfo.id,
      username: userInfo.username,
      solution: 'sara',
      //User has accepted the EULA by not setting an explicit software version
      //we let it be set by the backend 
      //based on statsol\etc\misc\eula.json
      notes: 'EULA accepted',
      accepted_date: dateString,
    };
    const meta = {
      method: 'POST',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].usereuladata,
      onSuccess: PROCESS_EULA,
      onError: '',
      auth: store.getState().auth.token,
      body: true,
      history: action.payload,
    };
    store.dispatch(showLoading());
    store.dispatch(apiRequest(body, meta));
  }
};

/**
 * Middleware to process if an error occurs during the api request
 */
export const eulaError = (store) => (next) => (action) => {
  next(action);
  if (action.type === EULA_ERROR) {
    store.dispatch(hideLoading());
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="eulaMiddleware.errorText"
          defaultMessage="There was an error"
          description="The user statuses were not able to be loaded"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};

export const eulaMdl = [acceptEula, eulaError];
